let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fkVsa")).then(() => parcelRequire('BjOSK'));